import React, { useRef } from 'react';
import { motion, useScroll, useTransform, useSpring } from 'framer-motion';
interface MaskRevealProps {
  children: React.ReactNode;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right';
  delay?: number;
  perspective?: boolean;
  once?: boolean;
}
export function MaskReveal({
  children,
  className = '',
  direction = 'up',
  delay = 0,
  perspective = true,
  once = true
}: MaskRevealProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start 85%', 'start 35%']
  });
  // Smooth out the scroll progress
  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  // Map progress to clip-path based on direction
  const clipPath = useTransform(smoothProgress, [0, 1], [direction === 'up' ? 'inset(100% 0 0 0)' : direction === 'down' ? 'inset(0 0 100% 0)' : direction === 'left' ? 'inset(0 0 0 100%)' : 'inset(0 100% 0 0)', 'inset(0% 0% 0% 0%)']);
  // Map progress to 3D rotation
  const rotateX = useTransform(smoothProgress, [0, 1], [perspective && (direction === 'up' || direction === 'down') ? 8 : 0, 0]);
  const rotateY = useTransform(smoothProgress, [0, 1], [perspective && (direction === 'left' || direction === 'right') ? 8 : 0, 0]);
  // Map progress to scale and opacity
  const scale = useTransform(smoothProgress, [0, 1], [0.92, 1]);
  const opacity = useTransform(smoothProgress, [0, 0.3], [0, 1]);
  // Determine transform origin
  const transformOrigin = direction === 'up' ? 'bottom center' : direction === 'down' ? 'top center' : direction === 'left' ? 'center right' : 'center left';
  return <div ref={ref} className={className} style={{
    perspective: perspective ? '1200px' : 'none'
  }} data-id="element-130">
      <motion.div style={{
      clipPath,
      rotateX,
      rotateY,
      scale,
      opacity,
      transformOrigin,
      willChange: 'clip-path, transform, opacity'
    }} className="w-full h-full" data-id="element-131">
        {children}
      </motion.div>
    </div>;
}